module.exports = __webpack_public_path__ + "static/media/refresh.8453748e.svg";